import React from "react";

const Perfil = (props) => {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({
        });
    });
    let codigoPerfil = "";
    let textoTooltip = "";
    let lengthHasta = props.codigo.length >= 23 ? 23 : props.codigo.length;
    let cortarCaracterHasta = 23;
    if(props.codigo.length >= lengthHasta){
        textoTooltip = props.codigo;
        codigoPerfil = `${props.codigo.substr(0, cortarCaracterHasta)}...`;
    } else {
        codigoPerfil = props.codigo;
    }
    return (
        <li className="profile-item">
            <ul className="no-bullets">
                <li className="inlineListItem2 margin-xs">
                    <div className="box-profile">
                        {(props.producto) ?
                            <p>{props.producto}</p> :
                            <p>Todos los productos</p>
                        }
                    </div>
                </li>
                <li className="inlineListItem2 margin-xs">
                    <span className="ti-angle-right"></span>
                </li>                
                <li className="inlineListItem2">
                    <div className="box-profile">
                    <p style={{ whiteSpace:'normal' }} data-html="true" key={textoTooltip} data-toggle="tooltip" data-title={textoTooltip}>{codigoPerfil}</p>
                    </div>
                </li>
            </ul>
        </li>
    );
}

export default Perfil;